/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type MatchSummaryTablePlannerFragment = { id: string, name: string };

export type MatchSummaryTableMatchStatusFragment = { plannerId: string, inflowSource: string, hasTalked: boolean };

export const MatchSummaryTablePlannerFragmentDoc = gql`
    fragment MatchSummaryTablePlanner on Planner {
  id
  name
}
    `;
export const MatchSummaryTableMatchStatusFragmentDoc = gql`
    fragment MatchSummaryTableMatchStatus on MatchStatus {
  plannerId
  inflowSource
  hasTalked
}
    `;